import { ccfRoutes } from '@app/ccf/ccf-routes';
import supplyChainLogisticsImage from '@app/ccf/company-report/assets/supply-chain-logistics-page-image.png';
import Page from '@app/components/layout/page/page';
import Text from '@shared/components/content/text';
import TextList from '@shared/components/content/text-list';
import { generatePath, useNavigate } from 'react-router-dom';
import { useCCF } from '../../ccf-context';
import SupplyChainLogisticsTable from '../../components/scope-3/supply-chain-logistics/supply-chain-logistics-table';
import { reportSlugs } from '../../slugs';
import { useCategory } from '../../utils';
import EmptyCategoryPage from '../ccf-category-intro-page';

export default function SupplyChainLogisticsPage() {
  const { uuid: reportUuid } = useCCF();
  const navigate = useNavigate();
  const category = useCategory(reportSlugs.supplyChainLogistics);

  const description = (
    <>
      <Text>
        Under Scope 3 in the GHG Protocol, there are two categories covering
        transportation and distribution:
      </Text>
      <TextList>
        <li className="font-semibold">
          Category 4: Upstream Transportation and Distribution
        </li>
        <li className="font-semibold">
          Category 9: Downstream Transportation and Distribution
        </li>
      </TextList>
      <Text className="mt-3">
        Together these account for all the emissions from transportation and
        storage of goods in your supply chain from your Tier 1 suppliers (the
        businesses you purchase from directly) to the end consumers.
      </Text>
      <Text className="mt-3">
        Given the difficulty in accurately modelling this supply chain -
        particularly the steps which are outside of your control - we provide a
        simple way to estimate the emissions at a higher-level. We separate your
        supply chain into two broad stages, and then allow you to model common
        flows of products within those stages - ensuring a sufficient level of
        accuracy for your company report.
      </Text>
      <img className="mt-3" src={supplyChainLogisticsImage} />
    </>
  );

  return (
    <Page name="Supply Chain Logistics" page="subpage">
      {category.hasActivityData ? (
        <SupplyChainLogisticsTable />
      ) : (
        <EmptyCategoryPage
          categorySlug="supply-chain-logistics"
          description={description}
          primaryActionText="Get started"
          primaryActionProps={{
            onClick: () =>
              navigate(
                generatePath(ccfRoutes.SUPPLY_CHAIN_LOGISTICS_FLOWS, {
                  report_uuid: reportUuid,
                })
              ),
          }}
        />
      )}
    </Page>
  );
}
